import {Component, OnInit} from '@angular/core';
import {UtilsService} from '../../../services/utils.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Review} from '../../../models/review';
import {ReviewsService} from '../../../services/reviews.service';
import {OrganizationsService} from '../../../services/organizations.service';

@Component({
  selector: 'app-new-review',
  templateUrl: './new-review.component.html',
  styleUrls: ['./new-review.component.scss']
})
export class NewReviewComponent implements OnInit {

  review: Review = new Review();
  statusList = ['NOT_STARTED', 'PENDING', 'COMPLETE'];
  organizationId: string;

  constructor(private reviewsService: ReviewsService,
              private organizationService: OrganizationsService,
              private utilsService: UtilsService,
              private route: ActivatedRoute,
              private router: Router) {
    this.review.status = this.statusList[0];

  }

  ngOnInit() {
    this.organizationId = this.route.snapshot.paramMap.get('organizationId');
    if (this.organizationId) {
      this.organizationService.read(this.organizationId).subscribe(result => {
        if (result && !result.loading) {
          if (result.data && result.data['organization']) {
            this.review.organization = JSON.parse(JSON.stringify(result.data['organization']));
          } else {
            this.router.navigate(['/reviews/' + this.organizationId]);
          }
        }
      });
    } else {
      this.router.navigate(['/reviews']);
    }
  }

  createReview() {
    const requiredSuccess = this.utilsService.validateRequiredFields(this.review.clientName, this.review.status, this.review.review);
    if (requiredSuccess) {
      this.reviewsService.createReview(this.review).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Review Created !!', '');
          this.router.navigate(['/reviews/' + this.organizationId]);
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to create review.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/reviews/new-review/new-review.component.ts